import { createAuthClient } from "better-auth/react";
import { inferAdditionalFields } from "better-auth/client/plugins";
import { authUserAdditionalFields } from "@carry/shared";

const baseURL = import.meta.env.VITE_API_URL ?? "http://localhost:8080";

/**
 * admin 用の Better-Auth React クライアント。
 * - session / user は httpOnly Cookie ベースで保持される
 * - API リクエストは credentials:'include' 必須 (lib/api.ts の oRPC fetch でも同様)
 */
export const authClient = createAuthClient({
  baseURL,
  fetchOptions: {
    credentials: "include",
  },
  // user.additionalFields (role/status/publicId) を型推論に乗せる。定義は @carry/shared で
  // サーバ (betterAuth) と共有し型ドリフトを防ぐ (SSoT)。session.user.role/status が型付きになる。
  plugins: [inferAdditionalFields({ user: authUserAdditionalFields })],
});

export type Session = ReturnType<typeof authClient.useSession>["data"];
